export default __webpack_public_path__ + "static/brid-aeda30ebf0a9e8161b2dcd853cdc73f2.svg";